const { z } = require('zod');

const ZFirebaseConfig = z.object({
    apiKey: z.string().optional(),
    authDomain: z.string().optional(),
    databaseURL: z.string().optional(),
    projectId: z.string().optional(),
    storageBucket: z.string().optional(),
    messagingSenderId: z.string().optional(),
    appId: z.string().optional(),
    measurementId: z.string().optional(),
}).passthrough();

// Matches the fileStorage shape expected by server-configmap consumers.
// Also adds top-level baseUrl and profileImages for frontend url construction.
const ZStorageConfig = z.object({
    cloud: z.literal('gcp'),
    projectId: z.string()
        .describe('GCP project id owning the storage bucket.'),
    bucketName: z.string()
        .describe('GCS bucket name (private/legacy content: resumes, CV-parser output).'),
    publicBucketName: z.string()
        .describe('GCS bucket name for publicly-readable assets (company logos, profile images). UBLA on, allUsers granted roles/storage.objectViewer at bucket level.'),
    tempBucketName: z.string()
        .describe('GCS bucket name for short-lived/temporary uploads (e.g. guest CVs). Objects auto-delete after 30 days.'),
    baseUrl: z.string().url()
        .describe('Base URL for the private bucket (no trailing slash) - resumes, CV-parser output.'),
    publicBaseUrl: z.string().url()
        .describe('Public base URL for the public bucket (no trailing slash) - company logos, profile images.'),
    profileImages: z.object({
        baseUrl: z.string().url()
            .describe('Public base URL for profile image assets (no trailing slash).'),
        folder: z.string().describe('Bucket path prefix for profile image files.'),
    }),
    companyLogos: z.object({
        baseUrl: z.string().url()
            .describe('Public base URL for company logo assets (no trailing slash).'),
        folder: z.string()
            .describe('Bucket path prefix for company logo files.'),
    }),
    cvFolder: z.string().describe('GCS path prefix for recruiter CV files.'),
    cvGuestFolder: z.string().describe('GCS path prefix for guest CV uploads.'),
    cvOnboardingFolder: z.string().describe('GCS path prefix for onboarding CV assets.'),
    docsFolder: z.string().describe('GCS path prefix for general documents.'),
    inboxAttachmentsFolder: z.string().describe('GCS path prefix for inbound/outbound message attachments of all types (mail + SMS/WhatsApp media);'),
});

const ZRecruiterDashboardConfig = z.object({
    env: z.string(),
    apiUrl: z.string().url(),
    firebase: ZFirebaseConfig,
    talentUrl: z.string(),
});

const ZEmployerDashboardConfig = z.object({
    env: z.string(),
    apiUrl: z.string().url(),
    firebase: ZFirebaseConfig,
    webUrl: z.string().optional(),
});

const ZTalentDashboardConfig = z.object({
    env: z.string(),
    apiUrl: z.string().url(),
    firebase: ZFirebaseConfig,
    ethosiaHostname: z.string(),
    ethosiaCompanySlug: z.string().optional(),
});

const ZProfileCrawlerExtensionConfig = z.object({
    env: z.string(),
    apiUrl: z.string().url(),
    firebase: ZFirebaseConfig,
    webUrl: z.string(),
});

const ZLinkedinScrapingDashboardConfig = z.object({
    env: z.string(),
    apiUrl: z.string().url(),
    firebase: ZFirebaseConfig,
});

const ZLandingPageConfig = z.object({
    env: z.string(),
    apiUrl: z.string().url(),
    talentUrl: z.string(),
});

const ZDataAnnotatorDashboardConfig = z.object({
    env: z.string(),
    apiUrl: z.string().url(),
    firebase: ZFirebaseConfig,
});

const ZProfileCrawlerExtensionDispatcherConfig = z.object({
    env: z.string(),
    webUrl: z.string(),
});

const ZEnvConfig = z.object({
    storage: ZStorageConfig,
    appConfigs: z.object({
        'recruiter-dashboard': ZRecruiterDashboardConfig,
        'employer-dashboard': ZEmployerDashboardConfig,
        'talent-dashboard': ZTalentDashboardConfig,
        'profile-crawler-extension': ZProfileCrawlerExtensionConfig,
        'linkedin-scraping-dashboard': ZLinkedinScrapingDashboardConfig,
        'landing-page': ZLandingPageConfig,
        'data-annotator-dashboard': ZDataAnnotatorDashboardConfig,
        'profile-crawler-extension-dispatcher': ZProfileCrawlerExtensionDispatcherConfig,
    }),
});

const ZFrontendConfigmap = z.object({
    LOCAL: ZEnvConfig,
    DEV: ZEnvConfig,
    PROD: ZEnvConfig,
});

module.exports = {
    ZStorageConfig,
    ZFirebaseConfig,
    ZEnvConfig,
    ZFrontendConfigmap,
};
